const CSS_CLASSES = {
  ROOT: 'mdc-card',
  OUTLINED: 'mdc-card--outlined',
  PRIMARY_ACTION: 'mdc-card__primary-action',
  MEDIA: 'mdc-card__media',
  MEDIA_SQUARE: 'mdc-card__media--square',
  MEDIA_16_9: 'mdc-card__media--16-9',
  MEDIA_CONTENT: 'mdc-card__media-content',
  ACTIONS: 'mdc-card__actions',
  ACTIONS_FULL_BLEED: 'mdc-card__actions--full-bleed',
  ACTION_BUTTONS: 'mdc-card__action-buttons',
  ACTION_ICONS: 'mdc-card__action-icons',
  ACTION: 'mdc-card__action',
  ACTION_BUTTON: 'mdc-card__action--button',
  ACTION_ICON: 'mdc-card__action--icon',
};

export {CSS_CLASSES};
